<template>
  <header
    class="header-main-top d-flex justify-content-between align-items-center"
  >
    <div class="d-flex align-items-center">
      <div class="d-flex me-3 ms-3">
        <img
          src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/hire3xlogo.svg"
          alt=""
        />
      </div>
      <div class="grey-header-vertical-line"></div>
      <div
        style="width: auto"
        class="cv-bulders-path d-flex align-items-center ml-2"
      >
        <div class="hover-color up-txt-h6 pointer" @click="goToHome">
          Training
        </div>
        <div class="d-flex align-items-center" v-if="display">
          <img
            class="margin-set"
            src="../../assets/img/path-forward.svg"
            alt=""
          />
          <b-breadcrumb>
            <b-breadcrumb-item
              class="d-flex br-mr-set"
              v-for="(item, index) in levelList"
              :key="item.path"
              :active-class="item.meta.title"
              :active="item.active"
            >
              <div
                v-if="
                  item.redirect === 'noRedirect' ||
                  index == levelList.length - 1
                "
                :class="
                  index > levelList.length - 1
                    ? ''
                    : item.meta.title.length > 24
                    ? 'breadcrumb-ellipsis2'
                    : item.meta.title.length > 24
                    ? 'breadcrumb-ellipsis'
                    : ''
                "
                class="no-redirect"
              >
                <div class="rec-dashboard-tooltip">{{ item.meta.title }}</div>
                {{ item.meta.title }}
              </div>

              <div
                class="breadcrumbs-active-class pointer"
                :class="
                  index > levelList.length - 2
                    ? ''
                    : item.meta.title.length > 24
                    ? 'breadcrumb-ellipsis2'
                    : item.meta.title.length > 24
                    ? 'breadcrumb-ellipsis'
                    : ''
                "
                v-else
                @click.prevent="handleLink(item)"
              >
                <div class="rec-dashboard-tooltip">{{ item.meta.title }}</div>
                {{ item.meta.title }}
              </div>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <div
      v-if="userID"
      class="login-details position-relative me-3 d-flex align-items-center"
      style="gap: 35px"
    >
      <div class="position-relative">
        <div
          class="pointer d-flex flex-column justify-content-center align-items-center"
        >
          <img src="@/assets/img/home-header.svg" alt="" />
          <div class="header-tabs-txt mt-1">Home</div>
          <div class="home-page-line"></div>
        </div>
      </div>
      <div class="position-relative">
        <div
          class="pointer d-flex flex-column justify-content-center align-items-center"
          @click="openCandidate"
        >
          <img src="@/assets/img/profile-unsel-profile.svg" alt="" />
          <div class="not-sel-home mt-2">My Profile</div>
        </div>
      </div>
      <div class="d-flex" ref="profile-image">
        <div
          class="mr-4"
          :class="showdpcard ? 'profilepic-border-active' : 'profilepic-border'"
          style="border: 2.5px solid #fff"
        >
          <!-- :style="
                candidateInfo.primaryProfile &&
                candidateInfo.primaryProfile.isPrimaryProfilePictureUploaded
                  ? 'border: 2.5px solid #20639b'
                  : 'border: 2.5px solid #fff;'
              " -->
          <img
            @click="showdpcard = !showdpcard"
            class="br-50 h-100 w-100 pointer"
            :src="userData && userData.image ? userData.image : ''"
            alt=""
          />
        </div>
      </div>

      <!-- <div> -->
      <div
        class="tnt-sortcard headercard p-2 mt-2"
        v-if="showdpcard"
        v-closable="{
          exclude: ['profile-image'],
          handler: 'closeDpcard',
        }"
      >
        <!-- new design starts from here -->
        <div class="d-flex align-items-center profile-container w-100">
          <div style="width: 14%">
            <div class="d-flex">
              <div
                class="profile-container-img"
                style="border: 2.5px solid #fff"
              >
                <img
                  @click="showdpcard = !showdpcard"
                  class="br-50 h-100 w-100 pointer"
                  :src="userData && userData.image ? userData.image : ''"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            style="width: 86%; word-break: break-all"
            class="profile-container-font ms-2"
          >
            {{ fullName }}
          </div>
        </div>

        <div class="d-flex align-items-center mt-2 p-1 pointer hoverclass">
          <div class="me-2">
            <img
              class="h-100 w-100"
              src="../../assets/accountSetting.svg"
              alt=""
            />
          </div>
          <div class="profile-container-subhead">Account Settings</div>
        </div>

        <div class="d-flex align-items-center mt-2 p-1 pointer hoverclass">
          <div class="me-2">
            <img class="h-100 w-100" src="../../assets/help.svg" alt="" />
          </div>
          <div class="profile-container-subhead">Help</div>
        </div>

        <div class="new-profile-line mt-2"></div>

        <div
          class="d-flex align-items-center justify-content-center pointer p-1 hoverclass"
          @click="logout"
        >
          <div class="me-1">
            <img class="h-100 w-100" src="../../assets/signout.svg" alt="" />
          </div>
          <div class="sign-out-font">Log Out</div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div class="d-flex gap-3 justify-content-between me-3 pt-1" v-else>
      <div class="newoutline log-header">
        <b-button @click="logout" class="btn search-btn cl-btn btn-secondary"
          >Log in</b-button
        >
      </div>
      <div class="newoutline">
        <b-button @click="openSignUp" class="btn search-btn focus-btn">
          Sign up
        </b-button>
      </div>
    </div>
  </header>
</template>

<script>
import { getProcessedToken } from "@/utils/request";
import {
  getInfo,
  headerName,
  staticImage,
} from "@/views/TrainingFolder/Dashboard/api-client/dashboard";
export default {
  data() {
    return {
      userData: {},
      levelList: null,
      display: true,
      showdpcard: false,
      userID: null,
    };
  },
  watch: {
    $route(route) {
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    },
  },
  async created() {
    try {
      const response = await getInfo();
      this.userData = response.data.data;
      if (
        !this.userData.image &&
        this.userData.firstName &&
        this.userData.firstName.length &&
        this.userData.lastName &&
        this.userData.lastName.length
      ) {
        const imageData = await staticImage(
          this.userData.firstName[0] + this.userData.lastName[0]
        );
        this.userData.image = imageData.data.data.link;
      }
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    fullName() {
      if (this.userData && Object.keys(this.userData).length) {
        return `${this.userData.firstName} ${this.userData.lastName}`;
      }
      return "";
    },
    switchBreadcrumbs() {
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      switch (this.$route.name) {
        default:
          this.display = false;
          return null;
        case "Dashboard":
          this.display = true;
          matched.splice(0, 1, {
            redirect: "noRedirect",
            meta: {
              title: "Dashboard",
            },
          });
          return matched;
        case "CommunityView":
          this.display = true;
          matched.splice(0, 1, {
            redirect: "noRedirect",
            meta: {
              title: "Community",
            },
          });
          return matched;
        case "MarketPlace":
          this.display = true;
          matched.splice(0, 1, {
            redirect: "noRedirect",
            meta: {
              title: "MarketPlace",
            },
          });
          return matched;
        case "Certificate":
          this.display = true;

          if (this.$route.query.component === "Dashboard") {
            matched.splice(
              0,
              1,
              {
                name: "Dashboard",
                meta: {
                  title: "Dashboard",
                },
              },
              {
                meta: {
                  title: "Certificate",
                },
              }
            );
          } else {
            matched.splice(0, 1, {
              meta: {
                title: "Certificate",
              },
            });
          }

          return matched;

        case "CourseView":
          this.display = true;
          let components;
          const component = this.$route.query.component;
          if (component === "Dashboard") {
            components = [
              {
                name: "Dashboard",
                back: -1,
                meta: {
                  title: "Dashboard",
                },
              },
            ];
          } else if (component === "MarketPlace") {
            components = [
              {
                name: "MarketPlace",
                back: -1,
                meta: {
                  title: "Marketplace",
                },
              },
            ];
          } else if (component === "FilteredCoursesView") {
            components = [
              {
                name: "MarketPlace",
                back: -3,
                meta: {
                  title: "Marketplace",
                },
              },
              {
                name: "FilteredCoursesView",
                back: -2,
                meta: {
                  title: "Filtered Courses",
                },
              },
            ];
          } else {
            components = [
              {
                name: "Certificate",
                meta: {
                  title: "Certificate",
                },
              },
            ];
          }
          const flag = this.$route.query.flag;
          if (flag) {
            components[0].back = -2;
          }
          if (flag === "R") {
            components.push({
              back: -1,
              meta: {
                title: "Review",
              },
            });
          } else if (flag === "C") {
            components.push({
              back: -1,
              meta: {
                title: "Course Detail",
              },
            });
          } else if (flag === "I") {
            components.push({
              back: -1,
              meta: {
                title: "Instructor",
              },
            });
          }

          if (Array.isArray(matched)) {
            matched.splice(0, matched.length, ...components, {
              meta: {
                title: this.$route.query.courseName,
              },
            });
          } else {
            console.error("Error: `matched` is not an array.");
          }

          return matched;

        case "FilteredCourses":
        case "FilteredCoursesView":
          this.display = true;
          matched.splice(
            0,
            1,
            {
              name: "MarketPlace",
              meta: {
                title: "MarketPlace",
              },
            },
            {
              meta: {
                title: "All Course",
              },
            }
          );
          return matched;

        case "Review":
          this.display = true;
          let routeList = [];
          const fromComponent = this.$route.query.component;
          if (fromComponent === "Dashboard") {
            routeList = [
              {
                name: "Dashboard",
                back: -1,
                meta: {
                  title: "Dashboard",
                },
              },
              {
                meta: {
                  title: "Reviews",
                },
              },
            ];
          } else if (fromComponent === "CourseDetail") {
            routeList = [
              {
                name: "CourseDetail",
                back: -1,
                meta: {
                  title: "Course Detail",
                },
              },
              {
                meta: {
                  title: "Reviews",
                },
              },
            ];
          } else if (fromComponent === "Certificate") {
            routeList = [
              {
                name: "Certificate",
                back: -1,
                meta: {
                  title: "Certificate",
                },
              },
              {
                meta: {
                  title: "Reviews",
                },
              },
            ];
          } else if (fromComponent === "MarketPlace") {
            routeList = [
              {
                name: "MarketPlace",
                back: -1,
                meta: {
                  title: "MarketPlace",
                },
              },
              {
                meta: {
                  title: "Reviews",
                },
              },
            ];
          } else if (fromComponent === "Instructor") {
            routeList = [
              {
                name: "MarketPlace",
                back: -2,
                meta: {
                  title: "MarketPlace",
                },
              },
              {
                name: "Instructor",
                back: -1,
                meta: {
                  title: "Instructor",
                },
              },
              {
                meta: {
                  title: "Reviews",
                },
              },
            ];
          }
          if (Array.isArray(matched)) {
            matched.splice(0, matched.length, ...routeList);
          } else {
            console.error("Error: `matched` is not an array.");
          }
          return matched;
        case "Instructor":
          this.display = true;
          matched.splice(
            0,
            1,
            {
              name: "MarketPlace",
              meta: {
                title: "MarketPlace",
              },
            },
            {
              meta: {
                title: "Instructor",
              },
            }
          );
          return matched;

        case "CourseDetail":
          this.display = true;
          const baseRoute = {
            meta: {
              title: this.$route.query.courseName,
            },
          };

          if (
            this.$route.query.component === "Dashboard" ||
            this.$route.query.component === "Dashboards"
          ) {
            matched.splice(0, 1, {
              name: "Dashboard",
              meta: {
                title: "Dashboard",
              },
            });
          } else if (this.$route.query.component == "FilteredCoursesView") {
            matched.splice(
              0,
              1,
              {
                name: "MarketPlace",
                back: -2,
                meta: {
                  title: "MarketPlace",
                },
              },
              {
                name: "FilteredCoursesView",
                back: -1,
                meta: {
                  title: "All Courses",
                },
              }
            );
          } else if (this.$route.query.component === "Certificate") {
            matched.splice(0, 1, {
              name: "Certificate",
              back: -1,
              meta: {
                title: "Certificate",
              },
            });
          } else {
            matched.splice(0, 1, {
              name: "MarketPlace",
              meta: {
                title: "MarketPlace",
              },
            });
          }
          matched.push(baseRoute);
          return matched;
      }
    },
  },
  async created() {
    this.getBreadcrumb();
    this.userID = getProcessedToken();
    try {
      const response = await getInfo();
      this.userData = response.data.data;
      if (
        !this.userData.image &&
        this.userData.firstName &&
        this.userData.firstName.length &&
        this.userData.lastName &&
        this.userData.lastName.length
      ) {
        const imageData = await staticImage(
          this.userData.firstName[0] + this.userData.lastName[0]
        );
        this.userData.image = imageData.data.data.link;
      }
      console.log("in header", this.userData);
    } catch (error) {
      console.log(error);
    }

    try {
      const response = await headerName();
      if (response.status === 200) {
        const data = response.data.data;
        this.userData.firstName = data.firstName;
        this.userData.lastName = data.lastName;
      }
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    openLogin() {
      window.open("https://app.hire3x.com/login", "_self");
    },
    openSignUp() {
      window.open("https://app.hire3x.com/register", "_self");
    },
    openCandidate() {
      window.open(
        "https://candidate.hire3x.com/builder/myprofile",
        "_self"
      );
    },
    logout() {
      this.$store.dispatch("userVUEX/LogOut");
    },
    getBreadcrumb() {
      if (this.switchBreadcrumbs) {
        this.levelList = this.switchBreadcrumbs.filter(
          (item) =>
            item.meta && item.meta.title && item.meta.breadcrumb !== false
        );
        this.levelList[this.levelList.length - 1].active = true;
      }
    },
    handleLink(item) {
      const { redirect, path, name, back, query } = item;
      if (redirect) {
        this.$router.push(redirect);
        // this.$router.push(`/Jobs/Board/Chaitra%20B/L071222A001CU001`);
        return;
      }
      if (back) {
        this.$router.go(back);
      } else if (name) {
        this.$router.push({
          name: name,
          params: item.params,
          query: query,
        });
        return;
      }
      if (query) {
        this.$router.push({
          path: path,
          query: query,
        });
        return;
      }
    },
    goToHome() {
      this.$router.push({
        name: "Dashboard",
      });
    },
  },
};
</script>

<style>
.not-sel-home {
  color: #606060;
  font-size: var(--size-12);
  font-weight: var(--weight-M);
  font-family: "lato", sans-serif;
}

.header-tabs-txt {
  font-family: "Poppins", sans-serif;
  font-weight: var(--weight-M);
  font-size: var(--size-12);
  color: var(--bg-proTheme);
}

.home-page-line {
  position: absolute;
  background-color: #20639b;
  width: 70px;
  height: 3.5px;
  top: 52px;
  left: -17px;
  border-radius: 2px;
}

.rec-dashboard-tooltip {
  visibility: hidden;
  position: absolute;
  top: 50px;
  width: -moz-fit-content;
  width: fit-content;
  border: 1px solid #d9d9d9;
  box-shadow: 0px 4px 4px 0px #00000014;
  white-space: nowrap;
  padding: 4px 15px;
  background: #344054;
  border-radius: 8px;
  color: #696969;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 16px;
  background-color: #d9d9d9;
}

.rec-dashboard-tooltip::before {
  content: "";
  position: absolute;
  top: -4px;
  transform: translateX(-50%) rotate(45deg);
  width: 10px;
  height: 10px;
  border: 1px solid transparent;
  background: #d9d9d9;
  z-index: 1;
}

.no-redirect:hover .rec-dashboard-tooltip,
.breadcrumbs-active-class:hover .rec-dashboard-tooltip {
  visibility: visible;
  opacity: 1;
}

.header-main-top {
  background: #fcfcfc;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  padding: 0 0px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.profilepic-border {
  border-radius: 50%;
  border: 2.5px solid #20639b;
  height: 43px;
  width: 43px;
}

.profilepic-border:hover {
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.profilepic-border-active {
  border-radius: 50%;
  border: 2.5px solid #20639b;
  height: 43px;
  width: 43px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.br-50 {
  border-radius: 50%;
}

.tnt-sortcard {
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
  border-radius: 5px;
  top: 44px;
  right: 5px;
  padding: 5px 15px;
  position: absolute;
  z-index: 7;
  width: 250px;
  font-size: var(--size-13);
  color: #545454;
}

.profile-container {
  background: #20639b;
  border-radius: 5px;
  padding: 5px;
}

.profile-container-font {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  font-family: "Lato", sans-serif;
}

.profile-container-img {
  border-radius: 50%;
  /* border: 2.5px solid #20639b; */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  height: 30px;
  width: 30px;
}

.profile-container-back {
  border-radius: 50%;
  border: 2.5px solid #fff;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
}

.profile-container-subhead {
  color: #3a3c40;
  font-size: 14px;
  font-weight: 500;
  font-family: "Lato", sans-serif;
}

.sign-out-font {
  color: #20639b;
  font-size: 14px;
  font-weight: 500;
  font-family: "Lato", sans-serif;
}

.hoverclass:hover {
  background: #e8eff4;
  padding: 0.25rem !important;
}

.new-profile-line {
  border-bottom: 1px solid #cdc9c9;
}

.breadcrumb {
  margin: 0px !important;
}

.breadcrumb-ellipsis {
  width: 50px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}

.breadcrumb-ellipsis2 {
  max-width: 220px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}

/* .breadcrumb-item + .breadcrumb-item:before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: ">" !important;
} */

.no-redirect {
  color: #97a8be;
  cursor: text;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  font-family: "lato", sans-serif;
  margin-top: 1px;
}

.grey-header-vertical-line {
  background-color: #c4c4c4;
  height: 30px;
  width: 1px;
  margin-right: 15px;
}

.breadcrumb li {
  font-size: 0.85rem;
}

.breadcrumb li a:hover {
  opacity: 1;
}

.breadcrumb-item + .breadcrumb-item:before {
  float: left;
  padding-right: 0.5rem;
  content: url(../../assets/img/path-forward.svg) !important;
  color: #04101b;
  opacity: 0.5;
}

.breadcrumbs-active-class {
  font-weight: var(--weight-LM);
  font-size: var(--size-14);
  margin-left: 5px;
  color: #464667;
  background-color: transparent;
  text-decoration: none;
}

.breadcrumb li a {
  text-decoration: none !important;
}

.margin-set {
  margin: 0px 10px;
  padding-top: 4px;
}

.br-mr-set {
  padding-top: 3px !important;
}

/* 
.bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #d9d9d9 !important;
}
 
.bs-tooltip-top .arrow::before,
.bs-tooltip-auto[x-placement^="top"] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #d9d9d9 !important;
}
 
.tooltip-inner {
  max-width: 200px;
  color: #3a3c40 !important;
  text-align: center;
  background-color: #d9d9d9 !important;
  border-radius: 8px !important;
} */
.up-txt-h6 {
  font-family: "Poppins", sans-serif;
  line-height: 18px;
  color: #464667;
  font-weight: 600;
  margin: 4px 0px 0px 0px;
}
</style>
